import ar_white from "../../../assets/images/ar_white.svg";
import home_white from "../../../assets/images/home_white.svg";
import proban_pc from "../../../assets/images/proban_pc.webp";
import produban_mo from "../../../assets/images/produban_mo.webp";

export default function ProductssBanner() {
  return (
    <div className="w-full ">
      <div className="block md:hidden lg:hidden w-full relative  h-[12rem] mt-16">
        <img src={produban_mo} alt="mobi" className="w-full h-[12rem]" />
        <div className="w-full absolute top-0 h-[12rem] ">
          <div className="absolute bottom-[30%] right-[15%] flex flex-col gap-2 items-center justify-center">
            <div className="w-full h-[2.625rem] rounded-[40px] flex justify-center items-center ">
              <div className="flex items-center gap-2">
                <img src={home_white} alt="home1" />
                <img src={ar_white} alt="ar" />
              </div>
              <div>
                <p className="text-[1rem] font-normal text-white whitespace-nowrap">
                  Sản phẩm
                </p>
              </div>
            </div>
            <p className="text-[1.5rem] font-semibold text-white whitespace-nowrap">
              Sản phẩm của chúng tôi
            </p>
          </div>
        </div>
      </div>
      <div className="hidden md:block lg:block w-full relative h-[20rem] mt-28">
        <img src={proban_pc} alt="pc" className="w-full h-[20rem]" />
        <div className="w-full absolute top-0  h-[20rem] ">
          <div className="absolute bottom-[35%] right-[45%] md:right-[35%] lg:right-[40%] flex flex-col gap-2 items-center justify-center">
            <div className="w-full h-[2.625rem] rounded-[40px] flex items-center justify-center">
              <div className="flex items-center gap-2">
                <img src={home_white} alt="home1" />
                <img src={ar_white} alt="ar" />
              </div>
              <div>
                <p className="text-[1rem] font-normal text-white whitespace-nowrap">
                  Sản phẩm
                </p>
              </div>
            </div>
            <p className="text-[2.25rem] font-semibold text-white">
              Sản phẩm của chúng tôi
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
